import { actionTypes, getInitialState, stateKeys } from './config';
import {
  accountTypeChangeHandler,
  dataStartRowChangeHandler,
  fileChangeHandler,
  goToPreviewHandler,
  houseChangeHandler,
  importTypeChangeHandler,
  settingStepFieldChangeHandler,
  sheetChangeHandler,
} from './handlers';
import { stepKeys } from '../config/step';

const initialState = getInitialState();

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.house_change: {
      return { ...houseChangeHandler({ state, value: payload }) };
    }
    case actionTypes.account_type_change: {
      return { ...accountTypeChangeHandler({ state, value: payload }) };
    }
    case actionTypes.import_type_change: {
      return { ...importTypeChangeHandler({ state, value: payload }) };
    }

    case actionTypes.file_change: {
      return { ...fileChangeHandler({ state, payload }) };
    }

    case actionTypes.sheet_change: {
      return { ...sheetChangeHandler({ state, value: payload }) };
    }

    case actionTypes.file_upload_started: {
      return { ...state, [stateKeys.isFileUploading]: true };
    }

    case actionTypes.data_start_row_change: {
      return { ...dataStartRowChangeHandler({ state, value: payload }) };
    }

    case actionTypes.setting_field_change: {
      return { ...settingStepFieldChangeHandler({ state, ...payload }) };
    }

    case actionTypes.company_change: {
      const updatedState = accountTypeChangeHandler({
        state: houseChangeHandler({ state }),
      });

      return {
        ...updatedState,
        [stateKeys.step]: stepKeys.uploading,
      };
    }

    case actionTypes.step_change: {
      return { ...state, [stateKeys.step]: payload };
    }

    case actionTypes.go_to_preview: {
      return { ...goToPreviewHandler({ state, payload }) };
    }

    case actionTypes.add_preview_data: {
      return { ...state, [stateKeys.previewData]: payload };
    }

    case actionTypes.add_result_data: {
      const {
        errorsCount,
        errorsWorkbook,
        errorsFile,
        title: resultTitle,
      } = payload;

      const previewData = state[stateKeys.previewData];
      const allCount = previewData?.dataSource?.length || 0;

      const title =
        resultTitle ||
        `Загружено ${allCount - errorsCount} из ${allCount} записей`;

      return {
        ...state,
        [stateKeys.resultData]: { title, errorsWorkbook, errorsFile },
        [stateKeys.step]: stepKeys.result,
      };
    }

    case actionTypes.reset_state: {
      return getInitialState();
    }

    default:
      return state;
  }
};
